// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ETL-customized-content {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 12px;
  padding: 8px 0 0;
  width: 100%;
}

/* 多选框包装器 */
.etl-checkbox-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 12px;
  background-color: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 10px;
  width: 100%;
  cursor: pointer;
}

.etl-checkbox-wrapper:hover {
  background-color: #dbeafe;
  box-shadow: none;
}

/* 多选框样式 */
.etl-multi-select-checkbox {
  width: 20px !important;
  height: 20px !important;
  border-radius: 6px !important;
  border: 2px solid #3B82F6 !important;
  cursor: pointer !important;
  transition: all 0.2s ease !important;
  margin: 0 !important;
  flex-shrink: 0 !important;
  background-color: white !important;
}

.etl-multi-select-checkbox:checked {
  background-color: #3B82F6 !important;
  border-color: #3B82F6 !important;
}

.etl-multi-select-checkbox:hover {
  border-color: #2563EB !important;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15) !important;
}

/* 多选框标签 */
.etl-checkbox-label {
  font-size: 13px;
  font-weight: 800;
  color: #1d4ed8;
  margin: 0;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

/* 信息提示区域 */
.ETL-customized-content > div:not(.etl-checkbox-wrapper):not(.input-content) {
  width: 100%;
  text-align: center;
}

.card-text {
  font-size: 14px;
  color: #6B7280;
  text-align: center;
  margin: 4px 0;
}

.button-container {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 8px;
}

.button-container .org-btn {
  width: 100%;
  max-width: none;
}

.xml-select {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 1rem;
  margin-top: 1rem;
}

.xml-select label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 0.5rem;
  text-align: center;
}

.xml-select-option {
  width: 100%;
  padding: 10px 12px;
  border: 2px solid #E5E7EB;
  border-radius: 8px;
  font-size: 14px;
  color: #374151;
  background-color: white;
  cursor: pointer;
  transition: all 0.3s ease;
}

.xml-select-option:hover {
  border-color: #3B82F6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.xml-select-option:focus {
  outline: none;
  border-color: #3B82F6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
}

.xml-select-container {
  width: 100%;
  overflow: hidden;
}

.ETL-customized-content .org-btn {
  width: 100%;
  min-height: 38px;
  font-size: 13px;
}

.etl-selected-panel {
  margin: 16px 0 0;
  padding: 14px;
  border: 1px solid #bfdbfe;
  border-radius: 14px;
  background: #eff6ff;
}

.etl-selected-title {
  margin-bottom: 10px;
  color: #1d4ed8;
  font-size: 13px;
  font-weight: 800;
}

.etl-selected-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.etl-selected-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 30px;
  padding: 4px 8px 4px 10px;
  border: 1px solid #dbe3ef;
  border-radius: 999px;
  background: #ffffff;
  color: #334155;
  font-size: 12px;
  font-weight: 800;
}

.etl-selected-chip button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: #fee2e2;
  color: #be123c;
  font-size: 12px;
  font-weight: 800;
  line-height: 1;
}

.etl-info-panel,
.etl-warning-panel {
  width: 100%;
  padding: 12px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 700;
}

.etl-info-panel {
  border: 1px solid #dbeafe;
  background: #eff6ff;
  color: #1d4ed8;
}

.etl-warning-panel {
  border: 1px solid #fed7aa;
  background: #fff7ed;
  color: #c2410c;
}

.etl-info-line + .etl-info-line,
.etl-classes {
  margin-top: 6px;
}

.etl-classes strong {
  color: #334155;
}

.etl-class-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 6px;
}

.etl-class-chip {
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  padding: 2px 8px;
  border: 1px solid #bfdbfe;
  border-radius: 999px;
  background: #ffffff;
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 800;
}

.etl-muted {
  margin-left: 8px;
  color: #94a3b8;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ETLPage/ETLPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,SAAS;EACT,gBAAgB;EAChB,WAAW;AACb;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,oCAAoC;EACpC,0BAA0B;EAC1B,oCAAoC;EACpC,oBAAoB;EACpB,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,yDAAyD;AAC3D;;AAEA,UAAU;AACV;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":[".ETL-customized-content {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 12px;\n  padding: 8px 0 0;\n  width: 100%;\n}\n\n/* 多选框包装器 */\n.etl-checkbox-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 9px 12px;\n  background-color: #eff6ff;\n  border: 1px solid #bfdbfe;\n  border-radius: 10px;\n  width: 100%;\n  cursor: pointer;\n}\n\n.etl-checkbox-wrapper:hover {\n  background-color: #dbeafe;\n  box-shadow: none;\n}\n\n/* 多选框样式 */\n.etl-multi-select-checkbox {\n  width: 20px !important;\n  height: 20px !important;\n  border-radius: 6px !important;\n  border: 2px solid #3B82F6 !important;\n  cursor: pointer !important;\n  transition: all 0.2s ease !important;\n  margin: 0 !important;\n  flex-shrink: 0 !important;\n  background-color: white !important;\n}\n\n.etl-multi-select-checkbox:checked {\n  background-color: #3B82F6 !important;\n  border-color: #3B82F6 !important;\n}\n\n.etl-multi-select-checkbox:hover {\n  border-color: #2563EB !important;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15) !important;\n}\n\n/* 多选框标签 */\n.etl-checkbox-label {\n  font-size: 13px;\n  font-weight: 800;\n  color: #1d4ed8;\n  margin: 0;\n  cursor: pointer;\n  user-select: none;\n}\n\n/* 信息提示区域 */\n.ETL-customized-content > div:not(.etl-checkbox-wrapper):not(.input-content) {\n  width: 100%;\n  text-align: center;\n}\n\n.card-text {\n  font-size: 14px;\n  color: #6B7280;\n  text-align: center;\n  margin: 4px 0;\n}\n\n.button-container {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  margin-top: 8px;\n}\n\n.button-container .org-btn {\n  width: 100%;\n  max-width: none;\n}\n\n.xml-select {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  margin-bottom: 1rem;\n  margin-top: 1rem;\n}\n\n.xml-select label {\n  display: block;\n  font-size: 14px;\n  font-weight: 500;\n  color: #374151;\n  margin-bottom: 0.5rem;\n  text-align: center;\n}\n\n.xml-select-option {\n  width: 100%;\n  padding: 10px 12px;\n  border: 2px solid #E5E7EB;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #374151;\n  background-color: white;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.xml-select-option:hover {\n  border-color: #3B82F6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.xml-select-option:focus {\n  outline: none;\n  border-color: #3B82F6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);\n}\n\n.xml-select-container {\n  width: 100%;\n  overflow: hidden;\n}\n\n.ETL-customized-content .org-btn {\n  width: 100%;\n  min-height: 38px;\n  font-size: 13px;\n}\n\n.etl-selected-panel {\n  margin: 16px 0 0;\n  padding: 14px;\n  border: 1px solid #bfdbfe;\n  border-radius: 14px;\n  background: #eff6ff;\n}\n\n.etl-selected-title {\n  margin-bottom: 10px;\n  color: #1d4ed8;\n  font-size: 13px;\n  font-weight: 800;\n}\n\n.etl-selected-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.etl-selected-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 30px;\n  padding: 4px 8px 4px 10px;\n  border: 1px solid #dbe3ef;\n  border-radius: 999px;\n  background: #ffffff;\n  color: #334155;\n  font-size: 12px;\n  font-weight: 800;\n}\n\n.etl-selected-chip button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  padding: 0;\n  border: 0;\n  border-radius: 50%;\n  background: #fee2e2;\n  color: #be123c;\n  font-size: 12px;\n  font-weight: 800;\n  line-height: 1;\n}\n\n.etl-info-panel,\n.etl-warning-panel {\n  width: 100%;\n  padding: 12px;\n  border-radius: 12px;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.etl-info-panel {\n  border: 1px solid #dbeafe;\n  background: #eff6ff;\n  color: #1d4ed8;\n}\n\n.etl-warning-panel {\n  border: 1px solid #fed7aa;\n  background: #fff7ed;\n  color: #c2410c;\n}\n\n.etl-info-line + .etl-info-line,\n.etl-classes {\n  margin-top: 6px;\n}\n\n.etl-classes strong {\n  color: #334155;\n}\n\n.etl-class-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 6px;\n}\n\n.etl-class-chip {\n  display: inline-flex;\n  align-items: center;\n  min-height: 24px;\n  padding: 2px 8px;\n  border: 1px solid #bfdbfe;\n  border-radius: 999px;\n  background: #ffffff;\n  color: #1d4ed8;\n  font-size: 12px;\n  font-weight: 800;\n}\n\n.etl-muted {\n  margin-left: 8px;\n  color: #94a3b8;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
